import { QrCode, Share2, UtensilsCrossed, LayoutTemplate, Layers } from "lucide-react";

// Single source of truth for the Qora products (naming, accents, copy, assets, prices shown in marketing).
export const PRODUCTS = {
  qr: {
    key: "qr", name: "Qora QR", path: "/qora-qr", Icon: QrCode, accent: "#123C46", soft: "#e7f0ee",
    claim: "Non limitarti a creare un QR. Scopri come viene utilizzato.",
    short: "QR dinamici e statici con statistiche reali di scansione.",
    bullets: ["Crea QR statici e dinamici", "Cambia destinazione senza ristampare", "Monitora le scansioni nel tempo", "Confronta i QR dell'attività", "Analizza periodo, dispositivo, sistema e browser", "Metti in pausa o riattiva quando vuoi"],
    shots: ["/showcase/qr-stats.jpg", "/showcase/company-stats.jpg"],
    cta: "Scopri Qora QR", demo: "Prova Qora QR", price: { monthly: "9,90 €", yearly: "89 €" }, plan: "qr",
  },
  link: {
    key: "link", name: "Qora Link", path: "/qora-link", Icon: Share2, accent: "#2f7f78", soft: "#e6f3f0",
    claim: "La tua pagina essenziale. Gratis.",
    short: "Link, social e contatti in una pagina gratuita, senza carta.",
    bullets: ["Gratis per sempre, nessuna carta", "Logo, nome, descrizione e link ordinati", "Social, WhatsApp, telefono, email e sito", "Temi e palette base", "QR della pagina e URL pubblico", "Passa a Qora MiniSite quando vuoi, senza perdere nulla"],
    free: true,
    shots: ["/showcase/link-phone.jpg"],
    cta: "Crea la tua pagina gratis", demo: "Apri una Qora Link", price: { monthly: "0 €", yearly: "0 €" },
  },
  minisite: {
    key: "minisite", name: "Qora MiniSite", path: "/qora-minisite", Icon: LayoutTemplate, accent: "#0c2d34", soft: "#dff3ec", badge: "Nuovo",
    claim: "Più di un link. La tua attività in una pagina.",
    short: "Il mini sito one-page professionale: template di settore, blocchi drag & drop e Qora AI.",
    bullets: ["Template pronti per il tuo settore", "Qora AI: ti consiglia struttura, blocchi e CTA", "Hero, servizi, prodotti, gallery, video, prima/dopo", "Preventivi, prenotazioni, WhatsApp e CTA sticky", "Orari, mappa, FAQ, team, volantino PDF", "Analytics per blocco e per pulsante"],
    shots: ["/showcase/link-phone.jpg"],
    cta: "Scopri Qora MiniSite", demo: "Guarda le demo MiniSite", price: { monthly: "9,90 €", yearly: "89 €" }, plan: "minisite", trial: true,
  },
  menu: {
    key: "menu", name: "Qora Menu", path: "/qora-menu", Icon: UtensilsCrossed, accent: "#b4541a", soft: "#f6ece4",
    claim: "Il menù digitale che fa venire voglia di scegliere.",
    short: "Foto, video, allergeni, piatti consigliati, ricerca, filtri e PDF.",
    bullets: ["Foto e video dei piatti", "Sezione «Da provare» e badge", "Allergeni confermati dal gestore", "Ricerca e filtri rapidi", "Scheda prodotto con abbinamenti e suggeriti", "PDF professionale con QR al menù aggiornato"],
    shots: ["/showcase/menu-phone.jpg", "/showcase/menu-detail.jpg"],
    cta: "Scopri Qora Menu", demo: "Guarda un Qora Menu", price: { monthly: "14,90 €", yearly: "129 €" }, plan: "menu", trial: true,
  },
  complete: {
    key: "complete", name: "Qora Complete", path: "/qora-complete", Icon: Layers, accent: "#0c2d34", soft: "#e7f0ee", badge: "Il più conveniente",
    claim: "Tutto Qora. QR, MiniSite e Menu in un solo abbonamento.",
    short: "Il pacchetto completo: Qora QR + Qora MiniSite + Qora Menu, una sola dashboard.",
    bullets: ["Tutto Qora QR", "Tutto Qora MiniSite", "Tutto Qora Menu", "Una sola dashboard, un solo abbonamento", "Risparmi rispetto ai moduli separati", "Supporto prioritario"],
    shots: ["/showcase/qr-stats.jpg"],
    cta: "Attiva Qora Complete", demo: "Guarda le demo", price: { monthly: "24,90 €", yearly: "219 €" }, separate: "34,70 €", plan: "complete", trial: true,
  },
};
export const PRODUCT_LIST = [PRODUCTS.qr, PRODUCTS.link, PRODUCTS.minisite, PRODUCTS.menu];
export const NAV_PRODUCTS = [...PRODUCT_LIST, PRODUCTS.complete];

// Product tips shown by the landing popup until real, authorized events exist (never presented as customer activity).
export const PRODUCT_TIPS = [
  { product: "minisite", text: "Template di settore + Qora AI: la pagina della tua attività in pochi minuti." },
  { product: "menu", text: "Mostra foto e video dei tuoi piatti, con allergeni confermati." },
  { product: "qr", text: "Cambia destinazione anche dopo aver stampato il codice." },
  { product: "complete", text: "QR + MiniSite + Menu insieme: risparmi rispetto ai moduli separati." },
  { product: "menu", text: "Scarica il menù in PDF professionale, sempre aggiornato." },
  { product: "link", text: "Riunisci social, contatti e promozioni in un'unica pagina gratuita." },
];

// Demo scenarios — clearly labelled as examples. Replace with real testimonials (name, business, logo, quote, rating) when available.
export const SCENARIOS = [
  { kind: "Scenario", sector: "Serramenti", text: "Preventivi dal telefono, con prima/dopo dei lavori in evidenza.", product: "minisite" },
  { kind: "Scenario", sector: "Ristorante", text: "Aggiorna prezzi e piatti senza ristampare il menù.", product: "menu" },
  { kind: "Esempio di utilizzo", sector: "Evento", text: "Cambia la destinazione del QR anche dopo averlo stampato.", product: "qr" },
];
export const TESTIMONIALS = []; // real reviews only: [{ name, business, logo, quote, rating }]
